const BASE_ACTION = "CIP_ANALYTICS/";

export const SET_ANALYTICS_CHART_TAGS = `${BASE_ACTION}SET_ANALYTICS_CHART_TAGS`;
export const UPDATE_ANALYTICS_CHART_DURATION = `${BASE_ACTION}UPDATE_ANALYTICS_CHART_DURATION`;

export const SET_ANALYTICS_CHART_TAG_DATA_LOADING = `${BASE_ACTION}SET_ANALYTICS_CHART_TAG_DATA_LOADING`;
export const RESET_ANALYTICS_CHART_DATA = `${BASE_ACTION}RESET_ANALYTICS_CHART_DATA`;
export const SET_DURATION_RANGES = `${BASE_ACTION}ANALYTICS_CHART_DURATION_RANGES`;
export const RESET_ANALYTICS_CHART_TAGS_DATA = `${BASE_ACTION}RESET_ANALYTICS_CHART_TAGS_DATA`;
export const SET_ANALYTICS_PLOT_DATA = `${BASE_ACTION}SET_ANALYTICS_PLOT_DATA`;
export const SET_ANALYTICS_CURRENT_EDITVIEW = `${BASE_ACTION}SET_ANALYTICS_CURRENT_EDITVIEW`;
export const SET_ALARMS_HISTORY = `${BASE_ACTION}SET_ALARMS_HISTORY`;
export const UPDATE_ANALYTICS_ALARMS = `${BASE_ACTION}UPDATE_ANALYTICS_ALARMS`;
export const SAVE_ANALYTICS_ALARMS = `${BASE_ACTION}SAVE_ANALYTICS_ALARMS`;
export const RESET_SPIKE_LINE =  `${BASE_ACTION}RESET_SPIKE_LINE`;

const ANALYTICS_ACTIONS = {
  SET_ANALYTICS_CHART_TAG_DATA_LOADING,
  SET_ANALYTICS_CHART_TAGS,
  RESET_ANALYTICS_CHART_DATA,
  RESET_ANALYTICS_CHART_TAGS_DATA,
  SET_ANALYTICS_PLOT_DATA,
  UPDATE_ANALYTICS_CHART_DURATION,
  SET_DURATION_RANGES,
  SET_ANALYTICS_CURRENT_EDITVIEW,
  SET_ALARMS_HISTORY,
  UPDATE_ANALYTICS_ALARMS,
  SAVE_ANALYTICS_ALARMS,
  RESET_SPIKE_LINE
};

export default ANALYTICS_ACTIONS;
